import(/* webpackMode: "eager" */ "/home/ubuntu/download/69cfb1e334b9ae00142825d1/fajrulportfolio/src/app/not-found.tsx");
